//@flow

import { Map } from 'immutable';
import {
    GET_COMMENTS_SUCCESS,
    SELECT_COMMENT,
    START_DRAWING_COMMENT,
    FINISH_DRAWING_COMMENT,
    CANCEL_DRAWING_COMMENT
} from './../types/comments';

import {
    SIGN_OUT,
} from './../types/auth';

const INITIAL_MAP = Map({
    'comments': null,
    'selectedComment': null,
    'drawingComment': null
});

export default (state: Map<string, string | boolean | Object> = INITIAL_MAP, action) => {
    switch (action.type) {
        case GET_COMMENTS_SUCCESS:
            return state
                .set('comments', action.comments);

        case SELECT_COMMENT:
            return state
                .set('selectedComment', action.comment);

        case START_DRAWING_COMMENT:
            return state
                .set('drawingComment', action.comment);

        case CANCEL_DRAWING_COMMENT:
            return state
                .set('drawingComment', 'canceled');

        case FINISH_DRAWING_COMMENT:
            return state
                .set('drawingComment', 'finished');

        case SIGN_OUT:
            return INITIAL_MAP;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/comments.jsx